var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_840_42)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 15.8543C42.5592 15.8543 43.3368 15.8759 45.9288 15.9983C48.3264 16.1063 49.6296 16.5095 50.4936 16.8479C51.6384 17.2943 52.4592 17.8271 53.316 18.6839C54.1728 19.5407 54.7056 20.3615 55.152 21.5063C55.4904 22.3703 55.8864 23.6735 56.0016 26.0711C56.1168 28.6631 56.1456 29.4407 56.1456 35.9999C56.1456 42.5591 56.124 43.3367 56.0016 45.9287C55.8936 48.3263 55.4904 49.6295 55.152 50.4935C54.7056 51.6383 54.1728 52.4591 53.316 53.3159C52.4592 54.1727 51.6384 54.7055 50.4936 55.1519C49.6296 55.4903 48.3264 55.8863 45.9288 56.0015C43.3368 56.1167 42.5592 56.1455 36 56.1455C29.4408 56.1455 28.6632 56.1239 26.0712 56.0015C23.6736 55.8935 22.3704 55.4903 21.5064 55.1519C20.3616 54.7055 19.5408 54.1727 18.684 53.3159C17.8272 52.4591 17.2944 51.6383 16.848 50.4935C16.5096 49.6295 16.1136 48.3263 15.9984 45.9287C15.8832 43.3367 15.8544 42.5591 15.8544 35.9999C15.8544 29.4407 15.876 28.6631 15.9984 26.0711C16.1064 23.6735 16.5096 22.3703 16.848 21.5063C17.2944 20.3615 17.8272 19.5407 18.684 18.6839C19.5408 17.8271 20.3616 17.2943 21.5064 16.8479C22.3704 16.5095 23.6736 16.1135 26.0712 15.9983C28.6632 15.8759 29.4408 15.8543 36 15.8543ZM36 11.4263C29.3256 11.4263 28.4904 11.4551 25.8696 11.5775C23.256 11.6999 21.4704 12.1103 19.9008 12.7223C18.288 13.3415 16.9128 14.1839 15.552 15.5519C14.184 16.9199 13.3488 18.2879 12.7152 19.9079C12.1104 21.4703 11.6928 23.2559 11.5704 25.8767C11.448 28.4975 11.4192 29.3327 11.4192 36.0071C11.4192 42.6815 11.448 43.5167 11.5704 46.1375C11.6928 48.7511 12.1032 50.5367 12.7152 52.1063C13.3416 53.7119 14.184 55.0871 15.552 56.4479C16.92 57.8159 18.288 58.6511 19.908 59.2847C21.4704 59.8895 23.256 60.3071 25.8768 60.4295C28.4976 60.5519 29.3328 60.5807 36.0072 60.5807C42.6816 60.5807 43.5168 60.5519 46.1376 60.4295C48.7512 60.3071 50.5368 59.8967 52.1064 59.2847C53.712 58.6583 55.0872 57.8159 56.448 56.4479C57.816 55.0799 58.6512 53.7119 59.2848 52.0919C59.8896 50.5295 60.3072 48.7439 60.4296 46.1231C60.552 43.5023 60.5808 42.6671 60.5808 35.9927C60.5808 29.3183 60.552 28.4831 60.4296 25.8623C60.3072 23.2487 59.8968 21.4631 59.2848 19.8935C58.6584 18.2879 57.816 16.9127 56.448 15.5519C55.08 14.1839 53.712 13.3487 52.092 12.7151C50.5296 12.1103 48.744 11.6927 46.1232 11.5703C43.5096 11.4551 42.6744 11.4263 36 11.4263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23.3784C29.0304 23.3784 23.3784 29.0304 23.3784 36C23.3784 42.9696 29.0304 48.6216 36 48.6216C42.9696 48.6216 48.6216 42.9696 48.6216 36C48.6216 29.0304 42.9696 23.3784 36 23.3784ZM36 44.1936C31.4784 44.1936 27.8064 40.5288 27.8064 36C27.8064 31.4712 31.4784 27.8064 36 27.8064C40.5216 27.8064 44.1936 31.4712 44.1936 36C44.1936 40.5288 40.5216 44.1936 36 44.1936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1184 25.8337C50.7487 25.8337 52.0704 24.512 52.0704 22.8817C52.0704 21.2513 50.7487 19.9297 49.1184 19.9297C47.488 19.9297 46.1664 21.2513 46.1664 22.8817C46.1664 24.512 47.488 25.8337 49.1184 25.8337Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_42",
    x1: 10.5441,
    y1: 61.4558,
    x2: 61.4558,
    y2: 10.5441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1b1fa83d7ba96e5c9715834b40e0c41d.svg";
export { ForwardRef as ReactComponent };